import {
  Box,
  Flex,
  Image,
  Text,
  Heading,
  Icon,
  Link,
} from "@chakra-ui/react";
import { useSchoolsContext } from "../../../Contexts/schoolContext";
import useIcons from "../../../hooks/useIcons";
import { useThemeColors } from "../../../hooks/useThemeColors";

export default function SchoolInfo() {
  const { school } = useSchoolsContext();
  const colors = useThemeColors();
  const icons = useIcons();
  return (
    <Box
      minH={"220px"}
      flex={1}
      w={"100%"}
      display={"flex"}
      alignItems={"center"}
      //position={"relative"}
      px={5}
    >
      <Flex
        gap={5}
        w={"full"}
        p={5}
        borderRadius={"lg"}
        alignItems={"center"}
        zIndex={2}
        justify={"space-between"}
        flexDir={["column", "column", "row"]}
      >
        <Box position="relative" display="inline-block">
          <Image
            bg={colors.schoolAccent.glassBg}
            src={school?.avatar || colors.schoolPlaceholderLogo}
            boxSize="130px"
            borderRadius="lg"
            aspectRatio={1}
            objectFit="cover"
            backdropFilter="blur(2px)"
            border="1px solid"
            borderColor={colors.schoolAccent.glassBorder}
            
          />
          
        </Box>

        <Flex
          flexDir={"column"}
          justifyContent={"flex-end"}
          alignItems={{ base: "center", md: "flex-end" }}
        >
          <Heading
            textAlign={{ base: "center", md: "right" }}
            p={2}
            bg={colors.schoolAccent.bg}
            color={colors.schoolAccent.text}
            fontWeight={"bold"}
            borderRadius={"md"}
            fontSize={"2xl"}
          >
            {school?.name}
          </Heading>
          <Text
            textAlign={{ base: "center", md: "right" }}
            p={2}
            bg={colors.schoolAccent.bg}
            color={colors.schoolAccent.text}
            borderRadius={"md"}
            my={1}
          >
            {school?.footnote}
          </Text>
          {school?.website && (
            <Link
              mt={2}
              zIndex={2}
              w={"fit-content"}
              fontSize={"xs"}
              variant={"plain"}
              onClick={() =>
                window.open(school?.website, "_blank", "noopener,noreferrer")
              }
            >
              Visit School Website
              <Icon as={icons.utility.externalLink} />
            </Link>
          )}
        </Flex>
      </Flex>
    </Box>
  );
}
